import { createGlobalStyle } from "styled-components";
import { 
  montserratItalic,
  montserratLight,
  montserratRegular,
  montserratMedium,
  montserratSemiBold 
} from "../fonts/index";
import { getEnvironment } from "../utils/index";
import {files} from "../constants/index";

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Montserrat';
    src: url(${montserratLight}) format("woff");
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat';
    src: url(${montserratRegular}) format("woff");
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat-Italic';
    src: url(${montserratItalic}) format("woff");
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat';
    src: url(${montserratMedium}) format("woff");
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat';
    src: url(${montserratSemiBold}) format("woff");
    font-weight: 600;
    font-style: normal;
  }

  html,
  #root {
    padding: 0;
    margin: 0;
    min-height: 100vh;
    font-size: 12px;
    font-family: 'Montserrat';
    box-sizing: border-box;
    background: #F7F7F5;

    ${props => props.theme.mediaQueries.medium}{
      font-size: 20px;
    }
  }

  body {
    margin: 0;
    overflow: ${props => (props.isModalActive ? 'hidden !important' : 'auto')};
    
    height: 100%;

  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  ul {
    list-style: none;
  }

  h1 {
    font-size: 1.83rem;
    font-weight: 400;
    line-height: 30px;
    margin: 0;

    ${props => props.theme.mediaQueries.medium}{
      font-size: 1.3rem;
    }
  }

  h2 {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 30px;
    margin: 0;
  }
  h3 {
    font-size: 1.17rem;
    font-weight: 400;
    line-height: 30px;
    margin: 0;
  }
  h4 {
    font-weight: 400;
    margin: 0;
    color: #2e2e35;
    line-height: 1.4rem;
    font-size: medium;
    margin: 0;
  }

  h5,
  h6 {
    font-weight: 700;
    margin: 1rem 0 0rem 0;
    font-size: 1rem;
    color: #2e2e35;
    line-height: 1.4;
    font-size: medium;
    margin: 0;
    
  }

  a {
    text-decoration: none;
    color: #2e2e35;
  }

  p {
    font-size: 1.17rem;
    font-weight: normal;
    line-height: 20px;
    margin: 0;
  }

  fieldset {
    margin: 0;
  }

  img {
    height: 100%;
    width: 100%;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
  input[type="number"]::-webkit-inner-spin-button, 
  input[type="number"]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }

  .grecaptcha-badge { visibility: hidden; }
`

export default GlobalStyle 

